module.exports = __webpack_public_path__ + "static/media/app-4.f8ae44a9.jpg";